import { render, staticRenderFns } from "./ApprovalLog.vue?vue&type=template&id=06f976aa&scoped=true&"
import script from "./ApprovalLog.vue?vue&type=script&lang=js&"
export * from "./ApprovalLog.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalLog.vue?vue&type=style&index=0&id=06f976aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f976aa",
  null
  
)

export default component.exports